
import { useState } from "react";
import { Container } from "@/components/ui/container";
import { CaseStudyCard } from "@/components/services/advisory/CaseStudyCard";
import { caseStudies } from "@/data/caseStudyData";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export const CaseStudiesSection = () => {
  // Filter case studies that are relevant to Microsoft 365 Security
  // by looking for specific tags
  const relevantCaseStudies = caseStudies
    .filter(study => 
      study.tags.some(tag => 
        ['Microsoft 365', 'Microsoft 365 Security', 'Cloud Security', 'Microsoft Defender', 'Identity Management']
        .includes(tag)
      )
    )
    .slice(0, 3); // Limit to 3 case studies
  
  return (
    <section id="case-studies" className="py-16 bg-gray-50">
      <Container>
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-2 bg-purple-100 rounded-full text-purple-700 font-medium text-sm mb-4">
            Success Stories
          </div>
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl mb-6">
            Real Results for Real Businesses
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            See how organizations like yours have transformed their Microsoft 365 security posture and achieved measurable results.
          </p>
        </div>
        
        {relevantCaseStudies.length > 0 ? (
          <div className="space-y-8">
            {relevantCaseStudies.map((study, index) => (
              <CaseStudyCard 
                key={study.id || index} 
                title={study.title}
                industry={study.industry}
                companyType={study.companyType}
                challenge={study.challenge}
                solution={study.solution}
                results={study.results}
                testimonial={study.testimonial}
                tags={study.tags}
                redactedName={study.redactedName}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-12 bg-white rounded-lg shadow">
            <h3 className="text-xl font-medium text-gray-900 mb-2">No matching case studies</h3>
            <p className="text-gray-600">Please check back later for Microsoft 365 security case studies.</p>
          </div>
        )}
        
        <div className="mt-10 text-center">
          <Link to="/case-studies">
            <Button variant="outline" className="group">
              View All Case Studies
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
        </div>
      </Container>
    </section>
  );
};
